import { helper } from '@ember/component/helper';
import _capitalize from 'scaleflow/utils/capitalize';

export default helper(function capitalize([string]) {
  return _capitalize(string);
});
